module.exports = __webpack_public_path__ + "static/media/Vladimir_Osvald.5661f23c.jpg";